/**
 * Helpers para navegação lateral (favoritos + pesquisa).
 */

export function flattenNavItems(modules) {
  const out = [];
  (modules || []).forEach((mod) => {
    (mod.items || []).forEach((it) => {
      out.push({
        path: it.path,
        label: it.label,
        icon: it.icon,
        moduleId: mod.id,
        moduleLabel: mod.label,
        badgeKey: it.badgeKey,
      });
    });
  });
  return out;
}

export function resolvePinnedItems(pinnedPaths, flatItems) {
  if (!pinnedPaths?.length || !flatItems?.length) return [];
  const byPath = new Map(flatItems.map((it) => [it.path, it]));
  return pinnedPaths.map((p) => byPath.get(p)).filter(Boolean);
}

export function filterModulesExcludingPinned(modules, pinnedSet) {
  if (!pinnedSet?.size) return modules || [];
  return (modules || [])
    .map((mod) => {
      const items = (mod.items || []).filter((it) => !pinnedSet.has(it.path));
      if (items.length === 0) return null;
      return { ...mod, items };
    })
    .filter(Boolean);
}

export function filterByQuery(items, query) {
  const q = String(query || '').trim().toLowerCase();
  if (!q) return items || [];
  return (items || []).filter((it) => {
    const hay = `${it.label || ''} ${it.moduleLabel || ''} ${it.path || ''}`.toLowerCase();
    return hay.includes(q);
  });
}

export function filterModulesByQuery(modules, query) {
  const q = String(query || '').trim().toLowerCase();
  if (!q) return modules || [];
  return (modules || [])
    .map((mod) => {
      const items = (mod.items || []).filter((it) => {
        const hay = `${it.label || ''} ${mod.label || ''} ${it.path || ''}`.toLowerCase();
        return hay.includes(q);
      });
      if (items.length === 0) return null;
      return { ...mod, items };
    })
    .filter(Boolean);
}
